import React from "react";

const Header = () => {
  return (
    <div className="flex justify-between items-center p-4 border-b">
      <div>
        Dashboard
      </div>
    </div>
  );
};

export default Header;
